"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @typedef {Recover} Recover
 * @class MyCompany
 * @classdesc This class holds endpoints for the authorized user.
 * @param {Recover} recover - Recover Instance
 */
var MyCompany = /** @class */ (function () {
    function MyCompany(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof MyCompany
         * @returns {SuccessfulGetMyCompany} Returns a message and the users company
         * @description This endpoint is used to view a the authed user's company.
         */
        this.get = function () {
            return _this.recover.request("/my_company", "GET", null, null);
        };
    }
    return MyCompany;
}());
exports.default = MyCompany;
